import { Theme, Typography } from "@material-ui/core";
import StringUtil from "../../../app/util/StringUtil";
import ContentArea from "../../cmp/content/ContentArea";
import FlexNewLine from "../../cmp/flex/FlexNewLine";
import useWizardFormCtx from "../wizard/ctx-provider/useWizardFormCtx";
import { makeStyles } from "@material-ui/styles";
import Video from "./Video";
import ProduktLogo from "./ProduktLogo";
import BtnTarifrechner from "./BtnTarifrechner";
import React from "react";
import useGtmPageView from "../../usePageview";
import DLayerPageviewTitle from "../../../gtm/types/GtmPageviewTitleId";
import Kampange from "./Kampagne";

const useStyle = makeStyles((theme: Theme) => ({
    newLine: {
        marginTop: 30
    },

    subtitle1: {
        fontFamily: theme.typography.subtitle1.fontFamily
    },

}));

const NewLine: React.FC = () => {
    const classes = useStyle();
    return (<FlexNewLine className={classes.newLine} />);
}

const Homepage: React.FC = () => {
    const { wizardFormBo } = useWizardFormCtx();
    useGtmPageView(DLayerPageviewTitle.HOMEPAGE);
    const classes = useStyle();

    const name = wizardFormBo.antrag.vnName || undefined;
    const vorname = wizardFormBo.antrag.vnVorname || undefined;

    const prName = StringUtil.trim(`${vorname || ''} ${name || ''}`);
    const renderName = !StringUtil.isBlank(prName);

    return (
        <>
            <ContentArea>
                <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>

                    <div style={{ textAlign: 'center' }}>
                        {renderName
                            ? <Typography variant='h1' color='textPrimary'>Hallo <span style={{ fontWeight: 'bold' }}>{prName}</span>!</Typography>
                            : <Typography variant='h1' color='textPrimary'>Schön, dass Sie da sind!</Typography>
                        }
                        <Typography variant='h5' color='textPrimary' style={{ marginTop: 10 }}>Wir freuen uns über Ihr Interesse an unserer neuen​</Typography>
                    </div>

                    <NewLine />

                    <div style={{ width: '90%' }}>
                        <ProduktLogo />
                    </div>

                    <NewLine />

                    <Typography color='secondary' variant='body1' style={{ textAlign: 'center', fontWeight: 'bold' }}>
                        Der Schutz mit dem besonderen<span className={classes.subtitle1}> Plus</span>.
                    </Typography>

                    <NewLine />

                    {/* Kampagne */}
                    <Kampange />

                    <NewLine />

                    <Video />

                    <NewLine />

                    <Typography color='primary' variant='body2' style={{ textAlign: 'center' }}>
                        Ein Hund ist nicht nur ein Haustier, sondern ein vollwertiges Familienmitglied.<br />
                        Damit Ihr Vierbeiner auch in Notfällen gut versorgt ist und welche zusätzlichen Alltagshilfen Ihnen unser Schutz bietet, sehen Sie in diesem Video.
                    </Typography>

                    <NewLine />

                    <BtnTarifrechner />

                </div>

            </ContentArea>
        </>
    );
}

export default Homepage;